import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesAdmin() {
  const { user } = useContext(AuthContext);

  const secciones = [
    { section: "Cobranza", items: [
      { label: "Ventas", icon: "fas fa-money-bill-wave", color: "#16a34a", href: "/ListadoVentas", enabled: !!(user.menu_admin) },
      { label: "Estado Cuenta", icon: "fas fa-file-invoice-dollar", color: "#16a34a", href: "/EstadoCuenta", enabled: !!(user.menu_admin) },
      { label: "Abonos", icon: "fas fa-dollar-sign", color: "#16a34a", href: "/ListadoAbonos", enabled: !!(user.menu_admin) },
      { label: "Notas de Cargo", icon: "fas fa-money-check-alt", color: "#16a34a", href: "/ListadoNotasCargo", enabled: !!(user.menu_admin) },
      { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#16a34a", href: "/ListadoDevolucionesAdmin", enabled: !!(user.menu_admin) },
      { label: "Bancos", icon: "fas fa-university", color: "#16a34a", href: "/Bancos", enabled: !!(user.menu_admin) },
    ]},
    { section: "Configuración", items: [
      { label: "Conceptos Bonificaciones", icon: "fas fa-bars", color: "#0d9488", href: "/ListadoConceptosBonificaciones", enabled: !!(user.menu_admin) },
      { label: "Bonificaciones", icon: "fas fa-search-dollar", color: "#0d9488", href: "/ListadoBonificaciones", enabled: !!(user.menu_admin) },
      { label: "Empresas", icon: "fas fa-industry", color: "#0d9488", href: "/ListadoEmpresas", enabled: !!(user.menu_admin) },
    ]},
    { section: "Reportes", items: [
      { label: "Proyeccion de Ingresos", icon: "fas fa-chart-line", color: "#7c3aed", href: "/AntiguedadSaldosPorCobrar", enabled: !!(user.menu_admin && user.menu_reportes) },
      { label: "Antiguedad Saldos Vencido", icon: "fas fa-chart-line", color: "#7c3aed", href: "/AntiguedadSaldosVencido", enabled: !!(user.menu_admin && user.menu_reportes) },
      { label: "Reporte Operativo", icon: "fas fa-chart-line", color: "#7c3aed", href: "/ReporteOperativo", enabled: !!(user.menu_admin && user.menu_reportes) },
    ]},
  ];

  return (
    <MenuBotones
      titulo="Admin / CxC"
      descripcion="Ventas, cobranza y reportes"
      icono="fas fa-file-invoice-dollar"
      color="#16a34a"
      secciones={secciones}
    />
  );
}

export default BotonesAdmin;
